import { HgSelectOptions, HgSupportedLanguage } from '@smg-real-estate/domus';
import { ComposerTranslation } from 'vue-i18n';

export const getVariantCPriceOptions = (defạultOption: string): HgSelectOptions[] => [
  { value: '0', text: defạultOption },
  { value: '500', text: '500 CHF' },
  { value: '600', text: '600 CHF' },
  { value: '700', text: '700 CHF' },
  { value: '800', text: '800 CHF' },
  { value: '900', text: '900 CHF' },
  { value: '1000', text: '1,000 CHF' },
  { value: '1100', text: '1,100 CHF' },
  { value: '1200', text: '1,200 CHF' },
  { value: '1300', text: '1,300 CHF' },
  { value: '1400', text: '1,400 CHF' },
  { value: '1500', text: '1,500 CHF' },
  { value: '1600', text: '1,600 CHF' },
  { value: '1700', text: '1,700 CHF' },
  { value: '1800', text: '1,800 CHF' },
  { value: '1900', text: '1,900 CHF' },
  { value: '2000', text: '2,000 CHF' },
  { value: '2200', text: '2,200 CHF' },
  { value: '2400', text: '2,400 CHF' },
  { value: '2600', text: '2,600 CHF' },
  { value: '2800', text: '2,800 CHF' },
  { value: '3000', text: '3,000 CHF' },
  { value: '3500', text: '3,500 CHF' },
  { value: '4000', text: '4,000 CHF' },
  { value: '4500', text: '4,500 CHF' },
  { value: '5000', text: '5,000 CHF' },
  { value: '5500', text: '5,500 CHF' },
  { value: '6000', text: '6,000 CHF' },
  { value: '7000', text: '7,000 CHF' },
  { value: '8000', text: '8,000 CHF' },
  { value: '9000', text: '9,000 CHF' },
  { value: '10000', text: '10,000 CHF' },
];

export const generateMonthlyIncomeSelectOptions = (
  t: ComposerTranslation,
  locale: string,
): HgSelectOptions[] => {
  const defaultOption = {
    text: t('leadQualification.householdIncome.defaultOption').toString(),
    value: '',
  };
  const firstOption = {
    text: t('leadQualification.householdIncome.firstOption').toString(),
    value: `0-${monthlyIncomeOptions[0].from}`,
  };
  const lastOption = {
    text: t('leadQualification.householdIncome.lastOption').toString(),
    value: `${monthlyIncomeOptions[monthlyIncomeOptions.length - 1].to}`,
  };
  const options = monthlyIncomeOptions.map((option) => ({
    text: t('leadQualification.householdIncome.priceRanges', {
      from: formatPriceByLocale(option.from, locale),
      to: formatPriceByLocale(option.to, locale),
    }).toString(),
    value: `${option.from}-${option.to}`,
  }));
  return [defaultOption, firstOption, ...options, lastOption];
};

const monthlyIncomeOptions: PriceOption[] = [
  { from: 3000, to: 5000 },
  { from: 5000, to: 7000 },
  { from: 7000, to: 9000 },
  { from: 9000, to: 11000 },
  { from: 11000, to: 13000 },
  { from: 13000, to: 15000 },
  { from: 15000, to: 20000 },
];

interface PriceOption {
  from: number;
  to: number;
}

const formatPriceByLocale = (price: number, locale: string): string => {
  if (/^[0-9]{4}$/.test(price.toString()) && locale !== HgSupportedLanguage.EN) {
    return price.toString();
  }

  const localeMapping: { [key: string]: string } = {
    [HgSupportedLanguage.IT]: HgSupportedLanguage.FR, //same format with French and Italian
    [HgSupportedLanguage.DE]: 'de-ch',
  };
  const formatLocale = localeMapping[locale] || locale;
  return new Intl.NumberFormat(formatLocale).format(price);
};
